<template>
  <!--消息模板分类-->
  <x-category></x-category>
</template>

<script>
export default {
  name: 'msgtplCate'
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/device/category/msgTpl/msgtplCate.vue